import { useFormat } from '@ideavivat/vivat-2';
import { visitorTypeTranslate } from '@/api/index';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '2rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    // eslint-disable-next-line
    created_at: {
      name: 'วันที่ลงทะเบียน',
      width: '10rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    name: {
      name: 'ชื่อ - นามสกุล',
      width: '1.5fr',
    },
    telephone: {
      name: 'เบอร์โทร',
      width: '8rem',
    },
    email: {
      name: 'อีเมล',
      width: '12rem',
    },
    // eslint-disable-next-line
    registration_type: {
      name: 'ประเภท',
      width: '12rem',
      // eslint-disable-next-line
      filter: (val: any, row: any) => val === 'OTHER' ? row.item?.other_register_type : visitorTypeTranslate(val),
    },
    organization: {
      name: 'องค์กร / หน่วยงาน',
      width: '10rem',
    },
    pin: {
      name: 'Passcode',
      width: '8rem',
    },
    // eslint-disable-next-line
    payment_status: {
      name: 'การชำระเงิน',
      width: '1fr',
      filter(val: any) {
        return val ? 'ชำระเรียบร้อย' : 'ยังไม่ได้ชำระ';
      },
    },
    // eslint-disable-next-line
    last_login: {
      name: 'เข้าใช้งานล่าสุด',
      width: '12rem',
      class: 'text-right',
      filter(val: any) {
        if (!val) return '';
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    _activeControls: {
      width: '3rem',
      name: 'สถานะ',
    },
  },
  sortable: ['name', 'created_at', 'registration_type', 'organization', 'paymentStatus', 'last_login'],
};
